/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class NewComputerGroupIcon extends BaseIcon {
  getChildren = () => [
    <g fill={ this.getColor() }>
      <rect width="1" height="4"/>
      <rect width="4" height="1"/>
      <rect x="13" width="1" height="4"/>
      <rect x="10" width="4" height="1"/>
      <rect y="10" width="1" height="4"/>
      <rect y="13" width="4" height="1"/>
      <g>
        <polygon points="8,9 8,8 6,8 4,8 4,4 10,4 10,6 11,6 11,3 3,3 3,9 6,9 6,10 8,10"/>
        <rect x="3" y="10" width="3" height="1"/>
      </g>
      <path
        d="M13.5,12L12,13.5V16h-1v-2.5L9.5,12H7v-1h2.5L11,9.5V7h0.9H12v2.5l1.5,1.5H16v1H13.5z M13,9h1v1h-1V9z M9,10V9  h1v1H9z M10,14H9v-1h1V14z M14,14h-1v-1h1V14z"/>
    </g>
  ]
  getViewBox = () => '0 0 16 16'
}
